export default "__VITE_ASSET__C5Zu9w4x__"